import { render, staticRenderFns } from "./TogglePlayButton.vue?vue&type=template&id=05def700&scoped=true"
import script from "./TogglePlayButton.vue?vue&type=script&lang=js"
export * from "./TogglePlayButton.vue?vue&type=script&lang=js"
import style0 from "./TogglePlayButton.vue?vue&type=style&index=0&id=05def700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05def700",
  null
  
)

export default component.exports